module.exports = __webpack_public_path__ + "images/FUSA_icons/008-dress.9f15f840703aff518e90d649816bfc57.svg";